import React from 'react';
import { CreditCard } from 'lucide-react';
export const PaymentBadges: React.FC = () => {
  return <div className="flex flex-col items-center justify-center space-y-2 mt-4" data-id="element-208">
      <p className="text-xs text-gray-500 font-medium uppercase tracking-wider" data-id="element-209">
        Pagos 100% Seguros
      </p>
      <div className="flex items-center space-x-3 text-gray-400" data-id="element-210">
        <div className="flex items-center justify-center bg-gray-50 border border-gray-200 rounded px-3 py-1.5" data-id="element-211">
          <span className="text-sm font-bold text-blue-800 italic" data-id="element-212">VISA</span>
        </div>
        <div className="flex items-center justify-center bg-gray-50 border border-gray-200 rounded px-3 py-1.5" data-id="element-213">
          <div className="flex -space-x-2" data-id="element-214">
            <div className="w-4 h-4 rounded-full bg-red-500 mix-blend-multiply" data-id="element-215"></div>
            <div className="w-4 h-4 rounded-full bg-yellow-500 mix-blend-multiply" data-id="element-216"></div>
          </div>
          <span className="text-xs font-bold text-gray-800 ml-1" data-id="element-217">
            mastercard
          </span>
        </div>
        <div className="flex items-center justify-center bg-gray-50 border border-gray-200 rounded px-3 py-1.5" data-id="element-218">
          <span className="text-sm font-bold text-blue-500" data-id="element-219">Mercado Pago</span>
        </div>
      </div>
    </div>;
};